const OptionList = () => {
  return (
    <div>
      <p>Option List</p>
    </div>
  );
};

export default OptionList;
